// eslint-disable-next-line import/unambiguous
import('./bootstrap');
